import { Box, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { Tooltip } from './Tooltip';
import { useTableStyles } from './utils';
export const MultiSpanTable = ({ entries, header }) => {
    const { tokens } = useContext(ThemeContext).theme;
    const { tableStyles, thStyles, tdStyles, trStyles } = useTableStyles();
    return (React.createElement("table", { style: tableStyles },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("th", { colSpan: 3, style: { ...thStyles, textAlign: 'center' } }, header)),
            entries.map((entry, entryIndex) => {
                return entry.items.map((item, itemIndex) => {
                    return (React.createElement("tr", { key: item.label, style: {
                            backgroundColor: entryIndex % 2 === 0 ? trStyles.backgroundColor : undefined
                        } },
                        itemIndex === 0 && (React.createElement("td", { rowSpan: entry.items.length, style: { ...tdStyles, padding: tokens.spacing.large } },
                            React.createElement(Text, { style: {
                                    fontWeight: tokens.text.weight.bold,
                                    textAlign: 'center'
                                } }, entry.title))),
                        React.createElement("td", { style: tdStyles },
                            React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "space-between", style: { gap: '5px' } },
                                React.createElement(Text, null, item.label),
                                item.labelTooltip && (React.createElement(Box, null,
                                    React.createElement(Tooltip, null, item.labelTooltip))))),
                        React.createElement("td", { style: tdStyles },
                            React.createElement(Text, { "data-ph-mask": true }, item.value))));
                });
            }))));
};
